<template>
    <section class="py-16">
        <h2 class="text-2xl font-bold text-center mb-12">{{ __('home::products.how_it_works') }}</h2>

        <div class="w-full max-w-screen-xl mx-auto px-6">
            <div class="grid lg:grid-cols-2 gap-x-4 gap-y-10 items-start">
                <div
                    v-for="index in [1, 2]"
                    :key="index"
                    class="flex flex-row lg:flex-col gap-x-6 gap-y-6 lg:justify-center lg:items-center lg:text-center"
                >
                    <video muted playsinline loop class="w-32 h-32 xs:w-36 xs:h-36 lg:w-56 lg:h-56">
                        <source :src="productGuide['video_' + index]" type="video/mp4">
                    </video>

                    <div>
                        <div class="xs:text-lg font-bold">{{ productGuide['title_' + index] }}</div>
                        <p class="text-sm xs:text-base mt-1">{{ productGuide['description_' + index] }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            productGuide: {
                'video_1': '/media/product-guide-step1.mp4',
                'title_1': this.__('home::products.guide_step1_title'),
                'description_1': this.__('home::products.guide_step1_description'),
                'video_2': '/media/product-guide-step2.mp4',
                'title_2': this.__('home::products.guide_step2_title'),
                'description_2': this.__('home::products.guide_step2_description'),
                'video_3': '/media/product-guide-step2.mp4',
                'title_3': this.__('home::products.guide_step3_title'),
                'description_3': this.__('home::products.guide_step3_description'),
            },
        }
    },
    created() {
        document.addEventListener('scroll', this.startVideoWhenInViewport);
    },
    methods: {
        startVideoWhenInViewport() {
            let container = this.$el;

            let rect = container.getBoundingClientRect();
            let requiredOffset = 50;
            let isInViewport = (rect.top - window.innerHeight + requiredOffset) < 0 ? true : false;

            if (isInViewport) {
                this.$el.querySelectorAll('video').forEach((el) => el.play());
                document.removeEventListener('scroll', this.startVideoWhenInViewport);
            }

        },
    },
}
</script>
